import React, { ReactElement } from "react";

export const ReplacePlaceholderByJSX = ({
  value,
  options
}: {
  value?: string;
  options: { [key: string]: ReactElement };
}): any => {
  if (!value) {
    return null;
  }

  const regex = Object.keys(options)
    .map((key) => `{${key}}`)
    .join("|");
  const parts = value.split(new RegExp(`(${regex})`, "g"));

  return (
    <>
      {parts.map((part: any) => {
        const probableKey = part.replace(/[{}]/g, "");
        return options[probableKey] ?? part;
      })}
    </>
  );
};
